import { render } from "./SportBets.vue?vue&type=template&id=7049c94b"
import script from "./SportBets.vue?vue&type=script&lang=js"
export * from "./SportBets.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__